import { EBannerType } from 'shared/constants/banner';

interface IGetBannerTypeParams {
  bannerType: EBannerType.RentNBListing | EBannerType.RentKpnCallback;
}

export const getBannerType = ({ bannerType }: IGetBannerTypeParams) => {
  switch (bannerType) {
    case EBannerType.RentNBListing:
      return 'new_link';
    case EBannerType.RentKpnCallback:
      return 'new_callback';
  }
};
